/**
 * @ngdoc controllers
 * @memberof mercury.modules.settings
 * @name SettingsCompanySubscriptionDialogCtrl
 */
angular.module('mercury.modules.settings.company')
.controller('SettingsCompanySubscriptionConfirmationDialogCtrl', ["$scope", "newFrequency", "dialog", function($scope, newFrequency, dialog) {
  $scope.dialog = dialog;
  $scope.newFrequency = newFrequency;
}]);
